//
//
//
//
//
//
//
//
//

export default {
    name: 'Tabs',
    data() {
        return {
            activeKey: this.defaultActiveKey || this.datas[0].key,
        };
    },
    props: {
        datas: Array,
        defaultActiveKey: String,
    },
    watch: {
        defaultActiveKey(val) {
            this.activeKey = val;
        },
    },
    computed: {
        // activeKey() {
        //     return this.defaultActiveKey || this.datas[0].key;
        // },
    },
    methods: {
        itemClick(activeKey) {
            this.activeKey = activeKey;
            this.$emit('item-click', activeKey);
        },
    },
};
